
export const APP_NAME = 'Sama.CRM';
export const APP_VERSION = '2.0';
export const APP_PHONE = '+971 55 469 6736';
export const APP_WHATSAPP = '+971 58 114 9388';
export const APP_WEBSITE = 'www.sama-tech.ae';
export const APP_EMAIL = 'info@sama-tech.ae';

export const BOOKING_THRESHOLD = 2 * 24 * 60 * 60 * 1000;
export const MEETING_THRESHOLD = 24 * 60 * 60 * 1000;
export const TICKET_THRESHOLD = 24 * 60 * 60 * 1000;
export const AXIOS_OPTIONS = { headers: { 'Content-Type': 'application/json' } };

export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || 'https://sama-tech.ae';
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || 'https://sama-tech.ae/crm';

export const BASE_URL = BASE_DOMAIN + '/crm'
export const BASE_URL_API = BASE_URL + '/api-v1'
// export const LICENSE_URL = 'http://localhost:8000/license/check-validity/BaselAlarashi'
